import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";

const HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFB9D1EA" },
};

const COLUMN_HEADER_FILL = {
  type: "pattern",
  pattern: "solid",
  fgColor: { argb: "FFD9D9D9" },
};
const THIN_BLACK = {
  top: { style: "thin", color: { argb: "FF000000" } },
  left: { style: "thin", color: { argb: "FF000000" } },
  bottom: { style: "thin", color: { argb: "FF000000" } },
  right: { style: "thin", color: { argb: "FF000000" } },
};

const BODY_FONT = { name: "Calibri", size: 11 };

const COL_START = 4;
const COL_END = 7;
const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

function borderCell(cell) {
  cell.border = THIN_BLACK;
}

function setCell(ws, row, col, value, options = {}) {
  const cell = ws.getCell(row, col);
  cell.value = value;
  cell.font = options.bold ? { ...BODY_FONT, bold: true } : BODY_FONT;
  borderCell(cell);
  cell.alignment = {
    horizontal: options.align || "center",
    vertical: "middle",
    wrapText: true,
  };
  if (options.fill) cell.fill = options.fill;
}

function normalizeExchanges(stockExchanges) {
  if (!stockExchanges) return [];
  if (Array.isArray(stockExchanges)) {
    return stockExchanges
      .map((item) => {
        if (typeof item === "string") return item.trim();
        if (typeof item === "object" && item !== null) {
          return String(item.name || item.exchange || "").trim();
        }
        return "";
      })
      .filter(Boolean);
  }
  if (typeof stockExchanges === "string" && stockExchanges.trim()) {
    return [stockExchanges.trim()];
  }
  return [];
}

export function buildStockExchangeSheet(workbook, sectionA) {
  const ws = workbook.addWorksheet("Stock exchange", {
    views: [{ showGridLines: true }],
  });

  const widths = { A: 2, B: 2, C: 2, D: 8, E: 28, F: 34, G: 22 };
  Object.entries(widths).forEach(([col, width]) => {
    ws.getColumn(col).width = width;
  });

  addSheetBackLink(ws, PARENT_SHEETS.GENERAL_DISCLOSURES, { mergeEnd: COL_END });

  const exchanges = normalizeExchanges(sectionA?.listedIdentity?.stockExchanges);

  ws.mergeCells(TITLE_ROW, COL_START, TITLE_ROW, COL_END);
  const tableTitle = ws.getCell(TITLE_ROW, COL_START);
  tableTitle.value = "Details of the Stock Exchanges";
  tableTitle.font = { ...BODY_FONT, bold: true };
  tableTitle.fill = HEADER_FILL;
  borderCell(tableTitle);
  tableTitle.alignment = { horizontal: "center", vertical: "middle" };

  const headers = [
    { col: COL_START, label: "Sr. No." },
    { col: 5, label: "Name of the Stock exchange" },
    { col: 6, label: "Description of other stock exchange" },
    { col: COL_END, label: "Name of the Country" },
  ];

  headers.forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, { bold: true, fill: COLUMN_HEADER_FILL, align: "center" });
  });

  const rows = exchanges.length ? exchanges : [""];

  rows.forEach((name, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_START, String(idx + 1), { align: "center" });
    setCell(ws, row, 5, name, { align: "left" });
    setCell(ws, row, 6, "", { align: "left" });
    setCell(ws, row, COL_END, "", { align: "left" });
  });

  return ws;
}
